import { render } from "./LinkModal.vue?vue&type=template&id=3c1bd0b2&scoped=true"
import script from "./LinkModal.vue?vue&type=script&lang=js"
export * from "./LinkModal.vue?vue&type=script&lang=js"

import "./LinkModal.vue?vue&type=style&index=0&id=3c1bd0b2&scoped=true&lang=css"

import exportComponent from "/var/www/html/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1bd0b2"]])

export default __exports__